//Librerias
import React, {useState, useEffect, useContext, useRef, useMemo} from "react";
import moment from "moment";
import {VictoryPie,  VictoryChart, VictoryBar, VictoryStack, VictoryAxis, VictoryLine, VictoryTheme, VictoryLegend, VictoryLabel} from 'victory';

//Contextos
import controlContext from "../../context/control/controlContext";
import usuariosContext from "../../context/usuarios/usuariosContext";

//Componentes
import AddFilter from "../addFilter/AddFilter";
import SearchInput from "../searchInput/SearchInput";
import FilterScreen from "../filterScreen/FilterScreen";

//Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeftLong,
  faDownload,
  faTableCells
} from "@fortawesome/free-solid-svg-icons";

//Utiles
import { STATES } from "../../utils/states";

import './Dashboard.css';
import { colors } from "@mui/material";
import { filtrosToString } from "../../utils/funciones";
import activoContext from "../../context/activoContex/activoContex";

const DashboardActivo = ({setGridToShow, usuario}) => {

    //Context control requerimientos
    const cContext = useContext(controlContext);
    const {filtrosEstado} = cContext;

    const {getInfoActivosDashboard, infoActivosDashboard} = useContext(activoContext);

    const [loading,setLoading] = useState(true);
    const [infoModelated,setInfoModelated] = useState(null);

    const firstLoadRef = useRef(true);

    useEffect(()=>{
        if(firstLoadRef.current){
            firstLoadRef.current = false;
            getInfoActivosDashboard(filtrosEstado)
            .then(res => {
                setLoading(false);
            })
        }
    },[])  

    useEffect(()=>{
        if(infoActivosDashboard) setInfoModelated({...infoModelated, ...infoActivosDashboard});
    },[infoActivosDashboard])

    const colorScalePriority = useMemo(()=>{
        if(infoModelated?.prioridad){
            let colorScale = [];
            for(let i = 0; i < infoModelated.prioridad.length; i++){
                if(infoModelated.prioridad[i].y > 0){
                    switch(i){
                        case 0:
                            colorScale.push('green');
                            break;
                        case 1:
                            colorScale.push('orange');
                            break;
                        case 2:
                            colorScale.push('red');
                            break;
                    }
                }
            }
            return colorScale;
        }
    },[infoModelated])
    
    const colorScaleStatus = useMemo(()=>{
        if(infoModelated?.estados){
            let colorScale = [];
            for(let i = 0; i < infoModelated.estados.length; i++){
                if(infoModelated.estados[i].y > 0){
                    switch(i){
                        case 0:
                            colorScale.push('gray');
                            break;
                        case 1:
                            colorScale.push('lightblue');
                            break;
                        case 2:
                            colorScale.push('#06b698');
                            break;
                    }
                }
            }
            return colorScale;
        }
    },[infoModelated])
    
    const widthGraphicHs = (infoModelated?.arrayVidaUtilHoras && infoModelated?.arrayVidaUtilHoras.length > 140) ? 17500 : (infoModelated?.arrayVidaUtilHoras && infoModelated?.arrayVidaUtilHoras.length > 50) ? 10000 : (infoModelated?.arrayVidaUtilHoras && infoModelated?.arrayVidaUtilHoras.length < 50 && infoModelated?.arrayVidaUtilHoras.length > 20) ? 6000 : (infoModelated?.arrayVidaUtilHoras && infoModelated?.arrayVidaUtilHoras.length <= 20) ? 1500 : 700; 

    const widthGraphicKm = (infoModelated?.arrayVidaUtilKilometros && infoModelated?.arrayVidaUtilKilometros.length > 140) ? 17500 : (infoModelated?.arrayVidaUtilKilometros && infoModelated?.arrayVidaUtilKilometros.length > 50) ? 10000 : (infoModelated?.arrayVidaUtilKilometros && infoModelated?.arrayVidaUtilKilometros.length < 50 && infoModelated?.arrayVidaUtilKilometros.length > 20) ? 6000 : (infoModelated?.arrayVidaUtilKilometros && infoModelated?.arrayVidaUtilKilometros.length <= 20) ? 1500 : 700; 

    return <div className="dashboardParentContainer">
        <div className="utilitiesDiv">
            <button onClick={()=>setGridToShow('')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong}/></button>
        </div>
        {
            loading ? <h3 className="warningStatusMsg">Estamos modelando su información<span>.</span><span>.</span><span>.</span></h3> : infoModelated && <div className="dashboardsDiv">
                <div className="dashboard" id="mainGraphicActivoDashboard">
                    <h3 className="headerLabel">Vida Útil Horas</h3>
                    <div className="infoContainer">
                        <div className="numbersDiv">
                            <div className="numbersData">
                                <h4>{infoModelated.totalHorasConsumidas}</h4>
                                <label className="lightGrayColor">Consumida</label>
                            </div>
                            <div className="numbersData">
                                <h4>{infoModelated.totalHorasDisponibles}</h4>
                                <label className="lightGreenColor">Disponible</label>
                            </div>
                        </div>
                        <div className="percentageDiv">
                            <div className="numbersData">
                                <h4>{infoModelated.porcentajeVidaUtilCompletadaHoras}%</h4>
                                <label>Porcentaje Total Consumido</label>
                            </div>
                        </div>
                    </div>
                    <div className="testGraphicContainer">
                        <div className="graphicContainerActivosLifeTime" style={{width: widthGraphicHs}}>
                            <VictoryChart domainPadding={50} padding={{left:100, top:50, bottom:50}} width={widthGraphicHs} height={400}>
                                <VictoryAxis
                                    tickFormat={(t) => t.toLocaleString("es-AR")}
                                    style={{
                                        tickLabels: { fontSize: 18, padding: 30 }, // font size for X axis ticks
                                        axisLabel: { fontSize: 15, padding: 30 } // font size and padding for X axis label
                                    }}
                                />

                                {/* Y Axis */}
                                <VictoryAxis
                                    dependentAxis
                                    tickFormat={(t) => t.toLocaleString("es-AR")}
                                    style={{
                                        tickLabels: { fontSize: 18 }, // font size for Y axis ticks
                                        axisLabel: { fontSize: 15, padding: 20 } // font size and padding for Y axis label
                                    }}
                                />
                                {
                                    (infoModelated?.arrayVidaUtilHoras && infoModelated?.arrayVidaUtilHoras.length > 0) && <VictoryStack colorScale={["#b0f2c2", "lightgray"]}>
                                        <VictoryBar
                                            style={{
                                                labels:{fontSize:15}
                                            }} 
                                            barWidth={60}
                                            labels={({ datum }) => datum.y}
                                            labelComponent={
                                                <VictoryLabel dy={30} /> // mueve el label hacia abajo
                                            }
                                            data={infoModelated?.arrayVidaUtilHoras}
                                        />
                                        <VictoryBar 
                                            style={{
                                                labels:{fontSize:15}
                                            }} 
                                            barWidth={60}
                                            labels={({ datum }) => datum.y}
                                            labelComponent={
                                                <VictoryLabel dy={15} /> // mueve el label hacia abajo
                                            }
                                            data={infoModelated?.arrayLastLecturaHoras}
                                        />
                                    </VictoryStack>
                                }
                            </VictoryChart>
                        </div>
                    </div>

                </div>
                
                <div className="dashboard" id="mainGraphicActivoDashboardHoras">
                    <h3 className="headerLabel">Vida Útil Kilómetros</h3>
                    <div className="infoContainer">
                        <div className="numbersDiv">
                            <div className="numbersData">
                                <h4>{infoModelated.totalKilometrosConsumidos}</h4>
                                <label className="lightGrayColor">Consumida</label>
                            </div>
                            <div className="numbersData">
                                <h4>{infoModelated.totalKilometrosDisponibles}</h4>
                                <label className="lightGreenColor">Disponible</label>
                            </div>
                        </div>
                        <div className="percentageDiv">
                            <div className="numbersData">
                                <h4>{infoModelated.porcentajeVidaUtilCompletadaKilometros}%</h4>
                                <label>Porcentaje Total Consumido</label>
                            </div>
                        </div>
                    </div>
                    {/* <div className="graphicContainerActivosLifeTime" style={{width: widthGraphicKm}}> */}
                    <div className="testGraphicContainer">
                        <div className="graphicContainerActivosLifeTime" style={{width: widthGraphicKm}}>
                        <VictoryChart domainPadding={50} padding={{left:100, top:50, bottom:50}} width={widthGraphicKm} height={400}>
                                <VictoryAxis
                                tickFormat={(t) => t.toLocaleString("es-AR")}
                                    style={{
                                        tickLabels: { fontSize: 18, padding: 30 }, // font size for X axis ticks
                                        axisLabel: { fontSize: 15, padding: 30 } // font size and padding for X axis label
                                    }}
                                />

                                {/* Y Axis */}
                                <VictoryAxis
                                    dependentAxis
                                    tickFormat={(t) => t.toLocaleString("es-AR")}
                                    style={{
                                        tickLabels: { fontSize: 18 }, // font size for Y axis ticks
                                        axisLabel: { fontSize: 15, padding: 20 } // font size and padding for Y axis label
                                    }}
                                />
                                {
                                    (infoModelated?.arrayVidaUtilKilometros && infoModelated?.arrayVidaUtilKilometros.length > 0) && <VictoryStack colorScale={["#b0f2c2", "lightgray"]}>
                                        <VictoryBar
                                            style={{
                                                labels:{fontSize:15}
                                            }} 
                                            barWidth={60}
                                            labels={({ datum }) => datum.y}
                                            labelComponent={
                                                <VictoryLabel dy={30} /> // mueve el label hacia abajo
                                            }
                                            data={infoModelated?.arrayVidaUtilKilometros}
                                        />
                                        <VictoryBar 
                                            style={{
                                                labels:{fontSize:15}
                                            }} 
                                            barWidth={60}
                                            labels={({ datum }) => datum.y}
                                            labelComponent={
                                                <VictoryLabel dy={15} /> // mueve el label hacia abajo
                                            }
                                            data={infoModelated?.arrayLastLecturaKilometros}
                                        />
                                    </VictoryStack>
                                }
                            </VictoryChart>
                        </div>
                    </div>
                </div>

            </div>
        }
    </div>

}

export default DashboardActivo;